import { createFileRoute } from '@tanstack/react-router';

import { Sessions } from '#modules/finder/features/posts/components/Sessions';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/sessions/_sessions/'
)({
  component: Sessions,
  ssr: false,
});
